import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq({ items }) {
  return (
    <Accordion type="single" collapsible className="border-t border-charcoal/10" data-testid="faq-accordion">
      {items.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} className="border-b border-charcoal/10">
          <AccordionTrigger className="py-5 text-left font-serif text-lg font-normal text-charcoal hover:text-forest hover:no-underline">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-base leading-relaxed text-charcoal/75">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
